import React, { useRef } from "react";
import css from '../style.scss';
import LeaveMessagePopup from "../modals/LeaveMessage";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const UploadProfilePicture = ({label, filed, setFieldValue, setImageUrl , leaveMessagePopup }) => {
  const fileInputRef = useRef(null);

  // Allowed MIME types
  const allowedFormats = [
    "image/jpeg",
    "image/png",
    "image/webp"
  ];

  const handleClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!allowedFormats.includes(file.type)) {
        leaveMessagePopup({
          title: "Invalid file format!",
          message: "Please upload JPEG, PNG, or WebP.",
          cancelLable: null,
          yesLable: 'Ok',
          yesRedirect: () => null,
        });
        event.target.value = ""; // Reset input to prevent uploading the invalid file
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1]; // Extract the Base64 string (exclude the "data:image/*;base64," prefix)
        
        // Update the marketingProfilePicture field in Formik with Base64
        setFieldValue(filed, base64String, null);

        // Set the image URL for previewing the uploaded image
        setImageUrl(base64String); // This includes the prefix and can be used as a source for an <img> tag
      };

      reader.readAsDataURL(file); // Read the file as a Base64 string
    }
  };

  return (
    <div>
      <a href="#" className={css.clsAddTxt} onClick={handleClick}>
        {label || 'Add Photo'}
      </a>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/jpeg, image/png, image/webp" // Prevents selecting unsupported files in most browsers
        onChange={handleFileChange}
      />
    </div>
  );
};

export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open
})(UploadProfilePicture));